import { FileDown } from 'lucide-react'

import type { NavItem } from '@/shared/layout/navigation'

/** Toda exportação pertence ao admin que pediu; não há permissão própria. */
export const exportsNavigation: NavItem[] = [
  { to: '/exports', labelKey: 'nav.exports', group: 'nav.groups.reports', icon: FileDown },
]
